import React, {

    useState

}

from "react";

import {

    OMNISCAN_BLUE

}

from "../../../constants/colors";

import DocumentBasketItem

from "./DocumentBasketItem";

import ImageComposerDrawer

from "./imagecomposer/ImageComposerDrawer";









//========================================================
// Document Basket
//
// Permanent source-content panel displayed beside the
// document canvas.
//
// Basket items remain available after being placed in the
// document. Placing content creates a reference from a
// document cell to the basket item; it does not consume it.
//
// Source images and derived images can also be selected for
// Nigel's Image Mangle.
//========================================================

export default function DocumentBasket({

    basketItems = [],

    basketUsage = {},

    onAddMergedImage

})

{

    //========================================================
    // Merge Selection
    //========================================================

    const [

        selectedImageIds,

        setSelectedImageIds

    ] = useState([]);





    //========================================================
    // Image Composer
    //========================================================

    const [

        imageComposerVisible,

        setImageComposerVisible

    ] = useState(false);









    //========================================================
    // Selected Images
    //
    // Both original source images and derived images are
    // valid Image Composer material.
    //========================================================

    const selectedImages =

        basketItems.filter(

            item =>

                isImageBasketItem(

                    item

                )

                &&

                selectedImageIds.includes(

                    item.basketId

                )

        );









    //========================================================
    // Can Merge Images
    //========================================================

    const canMergeImages =

        selectedImages.length >= 2;









    //========================================================
    // Toggle Merge Selection
    //========================================================

    const handleToggleMergeSelection = (

        basketId

    ) =>

    {

        setSelectedImageIds(

            current =>

            {

                if (

                    current.includes(

                        basketId

                    )

                )

                {

                    return current.filter(

                        id =>

                            id !== basketId

                    );

                }


                return [

                    ...current,

                    basketId

                ];

            }

        );

    };









    //========================================================
    // Merge Images
    //========================================================

    const handleMergeImages = () =>

    {

        if (

            !canMergeImages

        )

        {

            return;

        }


        setImageComposerVisible(

            true

        );

    };









    //========================================================
    // Close Image Composer
    //========================================================

    const handleCloseImageComposer = () =>

    {

        setImageComposerVisible(

            false

        );

    };









    //========================================================
    // Add Merged Image
    //
    // The Image Composer returns a real DERIVED_IMAGE basket
    // item containing the rendered PNG Blob and provenance.
    //
    // The parent owns the global basket, so the new item is
    // passed upwards for insertion into global state.
    //========================================================

    const handleAddMergedImage = async (

        mergedImage

    ) =>

    {

        //====================================================
        // Validate
        //====================================================

        if (

            !mergedImage

        )

        {

            return;

        }


        //====================================================
        // Parent Callback
        //====================================================

        if (

            onAddMergedImage

        )

        {

            await onAddMergedImage(

                mergedImage

            );

        }


        //====================================================
        // Clear Previous Merge Selection
        //
        // The source items remain in the basket. We simply
        // clear the COMBINE selection ready for another job.
        //====================================================

        setSelectedImageIds(

            []

        );

    };









    //========================================================
    // Render
    //========================================================

    return (

        <div style={styles.basket}>



            {/*============================================
                Header
            ============================================*/}

            <div style={styles.header}>

                <div>

                    <div style={styles.eyebrow}>

                        SOURCE CONTENT

                    </div>


                    <div style={styles.title}>

                        Document Basket

                    </div>

                </div>


                <div style={styles.count}>

                    {basketItems.length}

                </div>

            </div>









            {/*============================================
                Basket Content
            ============================================*/}

            <div style={styles.content}>

                {

                    basketItems.length === 0

                        ?

                        (

                            <div style={styles.empty}>

                                <div style={styles.emptyIcon}>

                                    +

                                </div>


                                <div style={styles.emptyTitle}>

                                    Your basket is empty

                                </div>


                                <div style={styles.emptyText}>

                                    Return to Document Search and
                                    select content to add source
                                    material to this document.

                                </div>

                            </div>

                        )

                        :

                        (

                            basketItems.map(

                                (item, index) =>

                                    <DocumentBasketItem

                                        key={

                                            item.basketId

                                        }

                                        item={

                                            item

                                        }

                                        index={

                                            index

                                        }

                                        placementCount={

                                            basketUsage?.[

                                                item.basketId

                                            ] || 0

                                        }

                                        mergeSelected={

                                            selectedImageIds.includes(

                                                item.basketId

                                            )

                                        }

                                        onToggleMergeSelection={

                                            handleToggleMergeSelection

                                        }

                                    />

                            )

                        )

                }

            </div>









            {/*============================================
                Merge Images
            ============================================*/}

            {

                canMergeImages &&

                (

                    <div style={styles.mergeContainer}>

                        <button

                            type="button"

                            style={styles.mergeButton}

                            onClick={

                                handleMergeImages

                            }

                        >

                            <span style={styles.mergeButtonCount}>

                                {

                                    selectedImages.length

                                }

                            </span>


                            <span>

                                MERGE {

                                    selectedImages.length

                                } IMAGES

                            </span>


                            <span style={styles.mergeArrow}>

                                →

                            </span>

                        </button>

                    </div>

                )

            }









            {/*============================================
                Footer
            ============================================*/}

            {

                basketItems.length > 0 &&

                (

                    <div style={styles.footer}>

                        <div style={styles.footerHint}>

                            Drag content onto a document cell

                        </div>

                    </div>

                )

            }









            {/*============================================
                Image Composer
            ============================================*/}

            <ImageComposerDrawer

                visible={

                    imageComposerVisible

                }

                images={

                    selectedImages

                }

                onClose={

                    handleCloseImageComposer

                }

                onAddMergedImage={

                    handleAddMergedImage

                }

            />

        </div>

    );

}









//========================================================
// Image Basket Item
//========================================================

function isImageBasketItem(

    item

)

{

    return (

        item?.basketContentType ===
            "IMAGE_SECTION"

        ||

        item?.basketContentType ===
            "DERIVED_IMAGE"

    );

}









//========================================================
// Styles
//========================================================

const styles =

{

    //========================================================
    // Basket
    //========================================================

    basket:

    {

        position:

            "fixed",

        width:

            380,

        minWidth:

            380,

        height:

            "100%",

        right:

            0,

        top:

            0,

        display:

            "flex",

        flexDirection:

            "column",

        background:

            "linear-gradient(180deg, #142431 0%, #0d1b26 100%)",

        borderLeft:

            "1px solid rgba(255,255,255,0.06)",

        boxShadow:

            "-12px 0 35px rgba(20,35,50,0.14)",

        boxSizing:

            "border-box",

        overflow:

            "hidden",

        zIndex:

            5000

    },





    //========================================================
    // Header
    //========================================================

    header:

    {

        height:

            84,

        minHeight:

            84,

        padding:

            "0 24px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        boxSizing:

            "border-box",

        borderBottom:

            "1px solid rgba(255,255,255,0.07)"

    },

    eyebrow:

    {

        marginBottom:

            5,

        color:

            OMNISCAN_BLUE,

        fontSize:

            9,

        fontWeight:

            700,

        letterSpacing:

            1.4

    },

    title:

    {

        color:

            "#ffffff",

        fontSize:

            17,

        fontWeight:

            600

    },

    count:

    {

        minWidth:

            30,

        height:

            30,

        padding:

            "0 7px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        borderRadius:

            5,

        background:

            "rgba(32,175,232,0.14)",

        border:

            "1px solid rgba(32,175,232,0.20)",

        color:

            OMNISCAN_BLUE,

        fontSize:

            12,

        fontWeight:

            700

    },





    //========================================================
    // Content
    //========================================================

    content:

    {

        flex:

            1,

        minHeight:

            0,

        padding:

            "18px 16px",

        overflowY:

            "auto",

        overflowX:

            "hidden",

        boxSizing:

            "border-box"

    },





    //========================================================
    // Empty
    //========================================================

    empty:

    {

        minHeight:

            240,

        padding:

            "30px 24px",

        display:

            "flex",

        flexDirection:

            "column",

        alignItems:

            "center",

        justifyContent:

            "center",

        textAlign:

            "center",

        boxSizing:

            "border-box"

    },

    emptyIcon:

    {

        width:

            42,

        height:

            42,

        marginBottom:

            16,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        border:

            "1px solid rgba(32,175,232,0.24)",

        borderRadius:

            6,

        background:

            "rgba(32,175,232,0.08)",

        color:

            OMNISCAN_BLUE,

        fontSize:

            23,

        fontWeight:

            300

    },

    emptyTitle:

    {

        marginBottom:

            7,

        color:

            "rgba(255,255,255,0.84)",

        fontSize:

            13,

        fontWeight:

            600

    },

    emptyText:

    {

        maxWidth:

            260,

        color:

            "rgba(255,255,255,0.38)",

        fontSize:

            11,

        lineHeight:

            1.6

    },





    //========================================================
    // Merge Images
    //========================================================

    mergeContainer:

    {

        padding:

            "12px 16px",

        boxSizing:

            "border-box",

        background:

            "rgba(8,20,29,0.96)",

        borderTop:

            "1px solid rgba(32,175,232,0.18)",

        boxShadow:

            "0 -8px 24px rgba(0,0,0,0.16)"

    },

    mergeButton:

    {

        width:

            "100%",

        height:

            46,

        padding:

            "0 14px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        gap:

            9,

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(32,175,232,0.55)",

        borderRadius:

            6,

        background:

            "rgba(32,175,232,0.14)",

        color:

            "#ffffff",

        fontSize:

            10,

        fontWeight:

            700,

        letterSpacing:

            0.8,

        cursor:

            "pointer",

        boxShadow:

            "0 6px 20px rgba(0,0,0,0.14)"

    },

    mergeButtonCount:

    {

        width:

            22,

        height:

            22,

        display:

            "inline-flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        borderRadius:

            11,

        background:

            OMNISCAN_BLUE,

        color:

            "#ffffff",

        fontSize:

            9,

        fontWeight:

            700

    },

    mergeArrow:

    {

        marginLeft:

            2,

        color:

            OMNISCAN_BLUE,

        fontSize:

            15,

        fontWeight:

            400

    },





    //========================================================
    // Footer
    //========================================================

    footer:

    {

        height:

            54,

        minHeight:

            54,

        padding:

            "0 18px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        borderTop:

            "1px solid rgba(255,255,255,0.07)"

    },

    footerHint:

    {

        color:

            "rgba(255,255,255,0.34)",

        fontSize:

            9,

        fontWeight:

            500

    }

};